export const environment = {
    production: false,
    productName: "Invictus",
    errMsg: 'Failed to complete. Please try again.',
    partner: false,
    multiregion: false,
    regions: [{
        regionId: "1",
        regionCode: "NA",
    }],
 
    config: {
        "auth": {
            "caretakerUrl": "https://caretaker.staging.service.75f.io/api/v1"
        },
        "edgeRunnerApi": "https://micropython-edge-api.azurewebsites.net/",
        'devCycleClientId':"dvc_client_cc642b22_a884_495c_bef7_4cc1a4c9b8f3_d9ba6b1",
        "externalServices": "https://external-services.staging.service.75f.io/",
        "userTractionUrl": "https://user-traction.staging.service.75f.io/",
        "helpCenter": "https://support.75f.io",
        "partnerName": "75F",
        "klipyApiKey": 'chJg8W90GkVk6F4D0hic2iJA3IKcyN2ihgHjqNEA3LMLXG6CL6GhwkZ3FExFBa3u',
        "1":{
            "regionName": "North America",
            "haystackUrl": "https://silo.staging.service.75f.io/",
            "siteSequencerUrl": "https://seq-runner.staging.service.75f.io",
            "notesUrl": "https://notes-api.staging.service.75f.io/",
            "filestorageUrl": "https://filestorage.staging.service.75f.io/",
            "equipBuilderUrl": "https://equip-builder.staging.service.75f.io/",
        }
    }
};
